import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Users, Tag, Image, MessageSquare, Zap, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/admin", label: "DASHBOARD", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "PRODUCTS", icon: Package },
  { to: "/admin/orders", label: "ORDERS", icon: ShoppingCart },
  { to: "/admin/customers", label: "CUSTOMERS", icon: Users },
  { to: "/admin/coupons", label: "COUPONS", icon: Tag },
  { to: "/admin/drops", label: "DROPS", icon: Zap },
  { to: "/admin/banners", label: "BANNERS", icon: Image },
  { to: "/admin/reviews", label: "REVIEWS", icon: MessageSquare },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen grid grid-cols-[240px_1fr]" data-testid="admin-layout">
      <aside className="border-r border-black/10 bg-white sticky top-0 h-screen">
        <Link to="/" className="block px-6 py-5 border-b border-black/10">
          <div className="flex items-center gap-2">
            <img src="/logo-be-512.png" alt="" className="h-7 w-7 object-contain" />
            <div className="font-display text-xl tracking-tighter leading-none">BYONDELMNTS</div>
          </div>
          <div className="text-[10px] font-mono text-black/40 mt-2 tracking-widest">ADMIN CONSOLE</div>
        </Link>
        <nav className="py-4">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={`admin-nav-${it.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-6 py-3 font-display tracking-widest text-xs border-l-2 ${
                    isActive ? "border-[#FF3B30] bg-black/5 text-black" : "border-transparent text-black/60 hover:text-black"
                  }`
                }
              >
                <Icon size={16} /> {it.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 border-t border-black/10 p-4">
          <div className="text-xs font-mono text-black/40">{user?.email}</div>
          <button onClick={logout} className="mt-2 w-full text-left text-xs font-display tracking-widest hover:text-[#FF3B30] flex items-center gap-2" data-testid="admin-logout">
            <LogOut size={14} /> LOGOUT
          </button>
        </div>
      </aside>
      <main className="bg-[#fafafa] min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
